module.exports = {
      id: "icon-audio-app-store-usage",
      viewBox: "0 0 122 41",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-audio-app-store",
      toString: function () {
        return this.url;
      }
    }